import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router";
import App from "./App";
import "./index.css";
import ErrorPage from "./views/Home/ErrorPage";
import { setWasmUrl } from "@lottiefiles/dotlottie-react";

// DotLottieReact uses its own WASM loader (separate from @lottiefiles/dotlottie-web),
// which defaults to fetching from cdn.jsdelivr.net/unpkg. Point it at the same-origin
// copy bundled into dist/ so it complies with our connect-src CSP.
setWasmUrl("/dotlottie-player.wasm");

const router = createBrowserRouter([
  {
    path: "*",
    element: <App />,
    errorElement: <ErrorPage />,
  },
]);

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
